import { Dimensions, StyleSheet } from 'react-native';
import colors from '@/config/colors';
const SCREEN_HEIGHT = Dimensions.get('window').height;

export const styles = StyleSheet.create({
  sideBar: {
    flex: 1,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
    paddingVertical: 10,
    width: '100%',
  },
  userBox: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 64,
    paddingHorizontal: 24,
    paddingRight: 45,
    paddingVertical: 8,
    gap: 16,
  },
  userImg: {
    width: 36,
    height: 36,
  },
  blurOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  buttonWrapper: {
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight: 70,
    paddingBottom: 18,
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    padding: 8,
    borderRadius: 8,
  },
  noPatientWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: SCREEN_HEIGHT * 0.7,
  },
  welcomeTextMain: {
    textAlign: 'center',
    marginTop: 20,
    fontWeight: 600,
    color: colors.newUI.therapist.blue90,
  },
  welcomeTextSubMain: {
    textAlign: 'center',
    fontWeight: 600,
    color: colors.newUI.therapist.blue90,
    paddingBottom: 20,
  },
  iconImageWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  iconStyle: {
    backgroundColor: colors.newUI.therapist.blue20,
    borderRadius: 50,
    padding: 10,
    position: 'absolute',
  },
  subTextMain: {
    textAlign: 'center',
    fontWeight: 600,
    color: colors.newUI.therapist.blue90,
    paddingTop: 20,
  },
  subTextSubMain: {
    textAlign: 'center',
    color: colors.newUI.therapist.blue90,
    paddingBottom: 20,
  },
});
